/**
 * This file was auto generated from scripts/generate-version.sh
 */
export const VERSION = '1.0.6';
//# sourceMappingURL=version.js.map